import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { OverviewComponent } from '../overview/overview.component';
import { DetailsComponent } from "../details/details.component";
import { LoginComponent } from "../login/login.component";
import { AddArticleComponent } from "../add-article/add-article.component";
import { HomeComponent } from "../home/home.component";
import { UserManagerComponent } from "../user-manager/user-manager.component";

const appRoutes:Routes = <Routes>[
  {path: 'home', component: HomeComponent},
  {path: 'overview', component: OverviewComponent},
  {path: 'details/:isbn', component: DetailsComponent},
  {path: 'login', component: LoginComponent},
  {path: 'add-article', component: AddArticleComponent},
  {path: 'user', component: UserManagerComponent},
  {path: '**', redirectTo: '/home'}
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/app-routing/app-routing.module.ts